import {
    getCustomerContains,
    getCustomerOptions,
} from '@/modules/Customer/services'
import { useEffect } from 'react'
import {
    FieldValues,
    Path,
    useFormContext,
    UseFormReturn,
    UseFormSetValue,
} from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import AsyncSelectWithServer from '../AsyncSelectWithServer'

interface CustomerSelectProps<T extends FieldValues> {
    control: UseFormReturn<T, any, any>['control']
    name: Path<T>
    multiple?: boolean
    showLabel?: boolean
    disabled?: boolean
    label?: string
    onChangeAfterHookForm?: () => void
    defaultCustomerID?: number
    setValue?: UseFormSetValue<any>
}

const CustomerSelect = <T extends FieldValues>({
    control,
    name,
    multiple,
    showLabel = true,
    disabled = false,
    label,
    onChangeAfterHookForm,
    defaultCustomerID,
    setValue: setValueProp,
}: CustomerSelectProps<T>) => {
    const { t } = useTranslation()
    const formContext = useFormContext()
    const setValue = setValueProp || formContext?.setValue
    useEffect(() => {
        if (defaultCustomerID && setValue) {
            setValue(name, defaultCustomerID as any)
        }
    }, [defaultCustomerID, setValue, name])

    return (
        <AsyncSelectWithServer<T>
            label={showLabel ? t(label || 'select-customer') : undefined}
            placeholder={t(label || 'select-customer')}
            control={control}
            name={name}
            asyncOptions={(value) =>
                getCustomerOptions({
                    page: 1,
                    page_size: 50,
                    q: value,
                })
            }
            multiple={multiple}
            getDefaultOptions={(value) =>
                getCustomerContains({
                    // BE /customers/contains nhận mảng customer_ids; single-select
                    // truyền scalar → ép về mảng để resolve được nhãn.
                    customer_ids: (Array.isArray(value)
                        ? value
                        : [value]) as number[],
                })
            }
            allowClear={false}
            onChangeAfterHookForm={onChangeAfterHookForm}
            disabled={disabled}
        />
    )
}

export default CustomerSelect
